import { useNavigate } from 'react-router-dom';
import { Spinner } from '@telegram-apps/telegram-ui';
import { hapticFeedback } from '@telegram-apps/sdk';
import { AccordionCard } from '../cards';
import { useTransferredRequests } from '../../hooks';
import '../cards/Cards.css';

export function TransferredList() {
  const navigate = useNavigate();
  const { data, isLoading, error } = useTransferredRequests();

  const handleRequestClick = (id: number) => {
    if (hapticFeedback.impactOccurred.isAvailable()) {
      hapticFeedback.impactOccurred('light');
    }
    navigate(`/request/${id}`);
  };

  if (isLoading) {
    return (
      <AccordionCard icon="↔️" title="Переведённые" subtitle="Загрузка..." defaultOpen={false}>
        <div className="loading-container" style={{ padding: '20px 0' }}>
          <Spinner size="m" />
        </div>
      </AccordionCard>
    );
  }

  if (error || !data) {
    return (
      <AccordionCard icon="↔️" title="Переведённые" subtitle="Ошибка загрузки" defaultOpen={false}>
        <div className="accordion-empty">Не удалось загрузить данные</div>
      </AccordionCard>
    );
  }

  const requests = data.data;

  return (
    <AccordionCard
      icon="↔️"
      title="Переведённые"
      subtitle={`${requests.length} заявок`}
      defaultOpen={false}
    >
      {requests.length === 0 ? (
        <div className="accordion-empty">Нет переведённых заявок</div>
      ) : (
        requests.map((req) => (
          <div
            key={req.id}
            className="request-brief-item"
            onClick={() => handleRequestClick(req.id)}
          >
            <span className="request-brief-id">#{req.id}</span>
            <span className="request-brief-subject">{req.subject}</span>
          </div>
        ))
      )}
    </AccordionCard>
  );
}
